import React from "react";
import { Container } from "./styles";
import InlineSVG from "react-inlinesvg";
import { REDO, UNDO } from "../hooks/useCanvasReducer";

export default ({
  setShowHelp, //
  changeZoom,
  zoom,
  dispatch,
}) => {
  return (
    <Container>
      <a
        className="show-help"
        onClick={(e) => {
          setShowHelp(true);
          e.preventDefault();
          e.stopPropagation();
        }}
      >
        ?
      </a>

      <div className="zoom">
        <a
          className="in"
          title="Zoom In"
          onClick={(e) => {
            e.preventDefault();
            changeZoom(zoom + 0.25);
          }}
        >
          +
        </a>
        <a
          className="out"
          title="Zoom Out"
          onClick={(e) => {
            e.preventDefault();
            changeZoom(zoom - 0.25);
          }}
        >
          &mdash;
        </a>
      </div>

      <div className="history">
        <a
          className="undo"
          title="Undo"
          onClick={(e) => {
            e.preventDefault();
            dispatch({ type: UNDO });
          }}
        >
          <InlineSVG src="/assets/undo.svg" />
        </a>
        <a
          className="redo"
          title="Redo"
          onClick={(e) => {
            e.preventDefault();
            dispatch({ type: REDO });
          }}
        >
          <InlineSVG src="/assets/redo.svg" />
        </a>
      </div>
    </Container>
  );
};
